import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class BarrioServices {
  private barrioApiUrl = `${environment.apiUrl}/barrio`;

  constructor(private http: HttpClient) {}

  crearBarrio(barrio: {
    nombre: string;
    acronimo: string;
    municipio: string | number;
  }): Observable<any> {
    return this.http.post<any>(this.barrioApiUrl, barrio);
  }

  obtenerBarriosPorMunicipio(municipioId: string | number): Observable<any> {
    return this.http.get<any>(`${this.barrioApiUrl}/${municipioId}`);
  }

  actualizarBarrio(
    id: string | number,
    barrio: { nombre: string; acronimo: string },
  ): Observable<any> {
    return this.http.patch<any>(`${this.barrioApiUrl}/${id}`, barrio);
  }

  eliminarBarrio(id: string | number): Observable<any> {
    return this.http.delete<any>(`${this.barrioApiUrl}/${id}`);
  }
}
